var map = {
	"./Kambi/SearchMobileMenuSection.js": [
		98486,
		78171
	],
	"./Kambi/SearchPCHeaderSection.js": [
		57957,
		1549,
		40872
	],
	"./Kambi/constants/index.js": [
		60436,
		579
	],
	"./Kambi/css/search.scss": [
		30468,
		59040
	],
	"./Kambi/sections/SearchHistory.js": [
		51739,
		23248
	],
	"./Kambi/sections/SearchResults.js": [
		59085,
		36078
	],
	"./Kambi/sections/SearchSection.js": [
		11960,
		96475
	],
	"./Kambi/utils/Search.utils.js": [
		19469,
		89589
	],
	"./Kambi/utils/useSearchHistorySubscription.js": [
		70198,
		76389
	],
	"./SearchHeaderSection.js": [
		42419,
		94818
	],
	"./SearchMenuSection.js": [
		73165,
		28368
	],
	"./Spectate/SearchMobileHeaderSection.js": [
		14625,
		91524
	],
	"./Spectate/SearchMobileMenuSection.js": [
		12387,
		54234
	],
	"./Spectate/SearchPCHeaderSection.js": [
		38336,
		48361
	],
	"./Spectate/css/search-header.scss": [
		35185,
		6497
	],
	"./Spectate/css/search-mobile-header.scss": [
		46368,
		75206
	],
	"./Spectate/css/search-mobile-menu.scss": [
		32078,
		50445,
		21456
	],
	"./Spectate/sections/SearchHeaderItem.js": [
		88472,
		14259
	],
	"./Spectate/sections/SearchMenuItem.js": [
		61078,
		75181
	],
	"./Spectate/utils/useIsOnSearch.js": [
		19995,
		83372
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 36188;
module.exports = webpackAsyncContext;